import useApi from 'common/hooks/useApi';
import React, { useEffect, useReducer, useState } from 'react';
import { useLocation } from 'react-router';
import reducer, { init } from './ResetQuestionsReducer';
import ResetQuestionsPresenter from './ResetQuestionsPresenter';
import validate from './ResetQuestionsValidate';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import { useHistory } from 'react-router-dom';
import AlertType from 'common/types/AlertType';

function ResetQuestionsContainer() {
  const [allowedToReset, setAllowedToReset] = useState(false);
  const [state, dispatch] = useReducer(reducer, init());
  const [attempts, setAttempts] = useState(0);
  const { push } = useHistory();
  const [{ data: allowedData, loading: allowedLoading }, verifyAllowedToReset] =
    useApi<ActionCompleteResponse>({
      url: '/register/verifyAllowResetQuestions',
      method: 'PUT',
      bypassTokenCheck: true,
    });
  const [{ data: resetData, loading: resetLoading }, resetRequest] =
    useApi<ActionCompleteResponse>({
      url: '/register/updateSecurityQuestions',
      method: 'PUT',
      bypassTokenCheck: true,
    });

  const location = useLocation();

  const onPageLoad = async () => {
    const params = new URLSearchParams(location.search);
    const { data } = await verifyAllowedToReset({
      email: params.get('email'),
      verifyId: params.get('verifyId'),
    });
    if (data && isActionCompleteSuccess(data)) {
      setAllowedToReset(true);
    }
  };

  useEffect(() => {
    onPageLoad();
  }, []);

  const handleQuestionChange = (num: '1' | '2' | '3') => (value: string) => {
    dispatch({
      type: 'updateSecurityQuestion',
      payload: { question: value, num },
    });
  };

  const handleAnswerChange = (num: '1' | '2' | '3') => (value: string) => {
    dispatch({ type: 'updateSecurityAnswer', payload: { answer: value, num } });
  };

  const handleSubmit = async () => {
    const params = new URLSearchParams(location.search);
    setAttempts((prev) => prev + 1);
    if (validate(state).length === 0) {
      const { data } = await resetRequest({
        email: params.get('email'),
        verifyId: params.get('verifyId'),
        questions: [
          {
            id: Number(state.security['1'].question),
            answer: state.security['1'].answer,
          },
          {
            id: Number(state.security['2'].question),
            answer: state.security['2'].answer,
          },
          {
            id: Number(state.security['3'].question),
            answer: state.security['3'].answer,
          },
        ],
      });
      if (data && isActionCompleteSuccess(data)) {
        push('/auth/login', {
          message: 'Your security questions were reset successfully.',
          type: AlertType.success,
        });
      }
    }
  };

  return (
    <>
      <ResetQuestionsPresenter
        allowedToResetResponse={allowedData}
        resetQuestionsResponse={resetData}
        allowedToReset={allowedToReset}
        allowedLoading={allowedLoading}
        onQuestionChange={handleQuestionChange}
        onAnswerChange={handleAnswerChange}
        onSubmit={handleSubmit}
        resetLoading={resetLoading}
        resetData={state}
        feedback={attempts > 0 ? validate(state) : []}
      />
    </>
  );
}

export default ResetQuestionsContainer;
